const ContactIcon = () => {
    return (
        <svg
            id="Group_8338"
            data-name="Group 8338"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
        >
            <g id="Group_8338-2" data-name="Group 8338">
                <path
                    id="Path_3559"
                    data-name="Path 3559"
                    d="M9.909,9.547a.673.673,0,0,0-.672-.672H6.547a.672.672,0,1,0,0,1.345H9.236a.673.673,0,0,0,.672-.672"
                    transform="translate(-1.925 -2.909)"
                    fill="#d6d6d6"
                />
                <path
                    id="Path_3560"
                    data-name="Path 3560"
                    d="M17.875,5.547a.673.673,0,0,1,.672-.672h3.361a.672.672,0,0,1,0,1.345H18.547a.673.673,0,0,1-.672-.672"
                    transform="translate(-5.858 -1.598)"
                    fill="#d6d6d6"
                />
                <path
                    id="Path_3561"
                    data-name="Path 3561"
                    d="M21.27,9.547a.673.673,0,0,0-.672-.672h-6.05a.672.672,0,0,0,0,1.345H20.6a.673.673,0,0,0,.672-.672"
                    transform="translate(-4.547 -2.909)"
                    fill="#d6d6d6"
                />
                <path
                    id="Path_3562"
                    data-name="Path 3562"
                    d="M5.875,5.547a.673.673,0,0,1,.672-.672H12.6a.672.672,0,0,1,0,1.345H6.547a.673.673,0,0,1-.672-.672"
                    transform="translate(-1.925 -1.598)"
                    fill="#d6d6d6"
                />
                <path
                    id="Path_3563"
                    data-name="Path 3563"
                    d="M15.959,13.547a.673.673,0,0,0-.672-.672H6.547a.672.672,0,1,0,0,1.345h8.739a.673.673,0,0,0,.672-.672"
                    transform="translate(-1.925 -4.22)"
                    fill="#d6d6d6"
                />
                <path
                    id="Path_3564"
                    data-name="Path 3564"
                    d="M23.892,13.547a.673.673,0,0,0-.672-.672h-.672a.672.672,0,1,0,0,1.345h.672a.673.673,0,0,0,.672-.672"
                    transform="translate(-7.169 -4.22)"
                    fill="#d6d6d6"
                />
                <path
                    id="Path_3565"
                    data-name="Path 3565"
                    d="M15.78,18.162a.672.672,0,0,0-.273-1.287H12.783a.672.672,0,1,0,0,1.345h2.724a.67.67,0,0,0,.273-.058"
                    transform="translate(-3.969 -5.53)"
                    fill="#d6d6d6"
                />
                <path
                    id="Path_3566"
                    data-name="Path 3566"
                    d="M17.854,9.659V1.613C17.854.93,17.5.375,16.825.375H3.61A1.228,1.228,0,0,0,2.392,1.613V6.565m0,3.159V6.565M.721,9.328a.526.526,0,0,0-.322.4,1.28,1.28,0,0,0-.024.245v8.665a1.228,1.228,0,0,0,1.218,1.238H18.653a1.228,1.228,0,0,0,1.218-1.238V9.968a1.28,1.28,0,0,0-.024-.245c-.095-.479-.671-.553-1.109-.35l-8.11,3.763a1.2,1.2,0,0,1-1.012,0L1.507,9.374A1.007,1.007,0,0,0,.721,9.328Zm0,0L2.392,6.565M19.525,9.328l-1.671-2.9"
                    transform="translate(-0.123 -0.123)"
                    fill="none"
                    stroke="#0c3b8d"
                    strokeWidth="0.75"
                />
            </g>
        </svg>
    );
};

export default ContactIcon;
